import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { UsuarioSesion } from 'src/app/models/usuario-sesion.interface';
import { AuthService } from 'src/app/services/auth.service';
import { SigninService } from 'src/app/services/signin.service';
import { ROLE } from 'src/app/shared/constantes/pages-usuarios';
import { RUTA } from 'src/app/shared/constantes/rutas-navegacion';
@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  providers: [MessageService]
})
export class SigninComponent {
  public isLoading: boolean = false;
  public form: FormGroup;
  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
    private router: Router,
    private signinService: SigninService) {
    this.form = this.crearForm();
  }

  get formulario() {
    return this.form.controls;
  }

  private crearForm() {
    return this.formBuilder.group({
      username: [null, [Validators.required]],
      contrasena: [null, [Validators.required]],
      isRecordarUsuario: [false]
    });
  }

  acceder(): void {

    const email = this.formulario['username'].value;
    const password = this.formulario['contrasena'].value;

    this.signinService.signin(email, password)
      .subscribe({
        next: (resp) => {
          this.inicializaInformacion(resp.datos.usuario, resp.datos.token);
          this.eleccion(resp.datos.usuario);
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err.error.message);
        }
      });
  }

  inicializaInformacion(usuario: UsuarioSesion, token: string): void {
    this.authService.setToken(token);
    this.authService.setUsuario(usuario);

  }

  eleccion(usuariosesion: UsuarioSesion): void {
    switch (usuariosesion.fk_rol) {
      case ROLE.ADMINISTRADOR:
        this.router.navigate([RUTA.CASOS_CLINICOS.ADMINISTRADOR]);
        break;
      case 2:
        this.router.navigate([RUTA.CASOS_CLINICOS.ADMINISTRADOR]);
        break;
      case ROLE.MEDICO:
        this.router.navigate([RUTA.CASOS_CLINICOS.MEDICO]);
        break;
      case 4:
        this.router.navigate(['']);
        break;
      case ROLE.ENFERMERA:
        this.router.navigate([RUTA.CASOS_CLINICOS.ENFERMERA]);
        break;
      case ROLE.SUPERVISOR:
        this.router.navigate([RUTA.CASOS_CLINICOS.SUPERVISOR]);
        break;
    }
  }

  showSuccess(): void {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Message Content' });
  }

  showError(mensaje: string): void {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: mensaje });
  }
}
